import { UserDatacenterView } from '../models/datacenter-aggrid-view';

export function normalizeViewName(viewName: string): string {
	return viewName.trim().toLowerCase().replace(/\s+/g, '-');
}

function safeDecodeURIComponent(value: string): string {
	try {
		return decodeURIComponent(value);
	} catch (error) {
		console.warn('Unable to decode view parameter', error);
		return value;
	}
}

function getViewTimestamp(view: UserDatacenterView): number {
	const dateValue = view.modificationDate ?? view.creationDate;
	if (dateValue === undefined) {
		return 0;
	}
	const ts = new Date(<string | number | Date>dateValue).getTime();
	return Number.isNaN(ts) ? 0 : ts;
}

export function resolveViewFromParam(
	viewParam: string | null,
	views: UserDatacenterView[],
	defaultView: UserDatacenterView
): { view: UserDatacenterView; found: boolean; decodedViewName?: string } {
	if (!viewParam) {
		return { view: defaultView, found: true };
	}

	if (/^\d+$/.test(viewParam.trim())) {
		const v = views.find(vw => vw.id === Number(viewParam));
		return { view: v ?? defaultView, found: Boolean(v) };
	}

	const decoded = safeDecodeURIComponent(viewParam);
	const normalized = normalizeViewName(decoded);
	const matches = views.filter(vw => normalizeViewName(vw.name) === normalized);

	if (matches.length === 0) {
		return { view: defaultView, found: false, decodedViewName: decoded };
	}

	if (matches.length === 1) {
		return { view: matches[0], found: true };
	}

	return { view: [...matches].sort((a, b) => getViewTimestamp(b) - getViewTimestamp(a))[0], found: true };
}
